import { render, staticRenderFns } from "./SingleProjectView.vue?vue&type=template&id=78b2165d&"
import script from "./SingleProjectView.vue?vue&type=script&lang=js&"
export * from "./SingleProjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports